import { createIcon } from "app/icons/createIcon";
import _FacebookSvgrepoCom1Icon from "./FacebookSvgrepoCom1Icon";
import _FooterAbtaIcon from "./FooterAbtaIcon";
import _FooterAtolIcon from "./FooterAtolIcon";
import _FooterAtoutFranceLogoIcon from "./FooterAtoutFranceLogoIcon";
import _FooterSetoLogoIcon from "./FooterSetoLogoIcon";
import _MessengerSvgrepoCom1Icon from "./MessengerSvgrepoCom1Icon";
import _PaiementAlmaIcon from "./PaiementAlmaIcon";
import _PaiementAmexBlackIcon from "./PaiementAmexBlackIcon";
import _PaiementAmexIcon from "./PaiementAmexIcon";
import _PaiementApplepayIcon from "./PaiementApplepayIcon";
import _PaiementCbBlackIcon from "./PaiementCbBlackIcon";
import _PaiementCbIcon from "./PaiementCbIcon";
import _PaiementFloaIcon from "./PaiementFloaIcon";
import _PaiementGooglepayBlackIcon from "./PaiementGooglepayBlackIcon";
import _PaiementGooglepayIcon from "./PaiementGooglepayIcon";
import _PaiementHintExpiryDateIcon from "./PaiementHintExpiryDateIcon";
import _PaiementHintSecurityIcon from "./PaiementHintSecurityIcon";
import _PaiementMastercardIcon from "./PaiementMastercardIcon";
import _PaiementPaypalBlackIcon from "./PaiementPaypalBlackIcon";
import _PaiementPaypalIcon from "./PaiementPaypalIcon";
import _PaiementVisaBlackIcon from "./PaiementVisaBlackIcon";
import _PaiementVisaIcon from "./PaiementVisaIcon";
import _PaiementMastercardBlackIcon from "./PaiementMastercardBlackIcon";
import _RatingAvisVerifiDemiIcon from "./RatingAvisVerifiDemiIcon";
import _RatingAvisVerifiIcon from "./RatingAvisVerifiIcon";
import _SocialFacebookIcon from "./SocialFacebookIcon";
import _SocialGoogleIcon from "./SocialGoogleIcon";
import _SocialInstaIcon from "./SocialInstaIcon";
import _Twitter154SvgrepoCom1Icon from "./Twitter154SvgrepoCom1Icon";
import _WhatsappSvgrepoCom1Icon from "./WhatsappSvgrepoCom1Icon";
import _XLogo20231Icon from "./XLogo20231Icon";

export const FacebookSvgrepoCom1Icon = createIcon(_FacebookSvgrepoCom1Icon);
export const FooterAbtaIcon = createIcon(_FooterAbtaIcon);
export const FooterAtolIcon = createIcon(_FooterAtolIcon);
export const FooterAtoutFranceLogoIcon = createIcon(_FooterAtoutFranceLogoIcon);
export const FooterSetoLogoIcon = createIcon(_FooterSetoLogoIcon);
export const MessengerSvgrepoCom1Icon = createIcon(_MessengerSvgrepoCom1Icon);
export const PaiementAlmaIcon = createIcon(_PaiementAlmaIcon);
export const PaiementAmexBlackIcon = createIcon(_PaiementAmexBlackIcon);
export const PaiementAmexIcon = createIcon(_PaiementAmexIcon);
export const PaiementApplepayIcon = createIcon(_PaiementApplepayIcon);
export const PaiementCbBlackIcon = createIcon(_PaiementCbBlackIcon);
export const PaiementCbIcon = createIcon(_PaiementCbIcon);
export const PaiementFloaIcon = createIcon(_PaiementFloaIcon);
export const PaiementGooglepayBlackIcon = createIcon(_PaiementGooglepayBlackIcon);
export const PaiementGooglepayIcon = createIcon(_PaiementGooglepayIcon);
export const PaiementHintExpiryDateIcon = createIcon(_PaiementHintExpiryDateIcon);
export const PaiementHintSecurityIcon = createIcon(_PaiementHintSecurityIcon);
export const PaiementMastercardIcon = createIcon(_PaiementMastercardIcon);
export const PaiementPaypalBlackIcon = createIcon(_PaiementPaypalBlackIcon);
export const PaiementPaypalIcon = createIcon(_PaiementPaypalIcon);
export const PaiementVisaBlackIcon = createIcon(_PaiementVisaBlackIcon);
export const PaiementVisaIcon = createIcon(_PaiementVisaIcon);
export const PaiementMastercardBlackIcon = createIcon(_PaiementMastercardBlackIcon);
export const RatingAvisVerifiDemiIcon = createIcon(_RatingAvisVerifiDemiIcon);
export const RatingAvisVerifiIcon = createIcon(_RatingAvisVerifiIcon);
export const SocialFacebookIcon = createIcon(_SocialFacebookIcon);
export const SocialGoogleIcon = createIcon(_SocialGoogleIcon);
export const SocialInstaIcon = createIcon(_SocialInstaIcon);
export const Twitter154SvgrepoCom1Icon = createIcon(_Twitter154SvgrepoCom1Icon);
export const WhatsappSvgrepoCom1Icon = createIcon(_WhatsappSvgrepoCom1Icon);
export const XLogo20231Icon = createIcon(_XLogo20231Icon);
